module.exports = __webpack_public_path__ + "vg.7dc61c2052d0dd17b4d8.svg";


//////////////////
// WEBPACK FOOTER
// D:/projects/feelway-pawnshop/pawnshop-web-client-feelway/src/assets/scss/icons/flag-icon-css/flags/vg.svg
// module id = ../../../../../src/assets/scss/icons/flag-icon-css/flags/vg.svg
// module chunks = styles